module.exports = __webpack_public_path__ + "img/disanfang.5cd87556.png";